module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/login-logo@3x__4ca4314438a3339769977b433adafded.png";